import * as Yup from "yup"
import { transformModelToJson } from "utils/transform"
import { PaginationSchema } from "model/_common"
import { ContentSchema } from "model/_base"

// Yup Schemas
export const ContentsSchema = Yup.object().shape({
  data: Yup.array().of(ContentSchema),
  pagination: PaginationSchema,
})

export class ContentsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = ContentsSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      })
      return model
    } catch (error) {
      throw error
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model)
  }
}
